<template>

<router-link to="/" class="wordmark" aria-label="whatboxart?">

	<app-mark :size="markSize" />

	<span class="wordmark-text">
		<span class="wordmark-lockup" :style="{ fontSize: size + 'px' }">
			<span class="wordmark-what">what</span><span class="wordmark-box">boxart</span><span class="wordmark-q">?</span>
		</span>
		<span class="wordmark-tag" v-if="tagline">A daily boardgame challenge</span>
	</span>

</router-link>

</template>

<script>

/*
	The whatboxart lockup: the checker Mark beside the wordmark, set in Newsreader.
	"what" is a muted warm neutral at weight 500, fused (no space) to "boxart" in
	ink at weight 600 — the weight + colour contrast carries the emphasis on
	"boxart". `size` is the wordmark font-size (px); the Mark scales with it.
	Hero ~40, topbar ~22. Always a link home; aria-label is "whatboxart".
*/

export default {

	props: {
		// wordmark font-size in px; the Mark scales proportionally
		size: {
			default: 22
		},
		tagline: {
			type: Boolean,
			default: false
		},
		// optional explicit Mark size (px); otherwise it scales with `size`
		mark: {
			default: null
		}
	},

	computed: {

		markSize: function() {

			if(this.mark != null) return Number(this.mark)

			return Math.round(Number(this.size) * 1.12)

		}

	}

}

</script>

<style scoped>

.wordmark {
	display: inline-flex;
	align-items: center;
	gap: 10px;
	text-decoration: none;
	color: var(--ink);
}

.wordmark-text {
	display: flex;
	flex-direction: column;
	line-height: 1;
}

.wordmark-lockup {
	font-family: var(--font-display);
	font-weight: 600;
	letter-spacing: -0.02em;
	line-height: 1;
	white-space: nowrap;
}

.wordmark-what {
	color: #bdb4a2;
	font-weight: 500;
}

.wordmark-box {
	color: var(--ink);
	font-weight: 600;
}

/* the question mark in geekgroup gold (the same #b8860b the footer wordmark
   uses) — a warm pop that sits on the cream ground */
.wordmark-q {
	color: #b8860b;
	font-weight: 600;
}

.wordmark-tag {
	font-family: var(--font-mono);
	font-size: 9px;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	color: var(--muted);
	margin-top: 0px;
}

/* very narrow phones: drop the tracking so the tagline still fits */
@media (max-width: 369px) {

	.wordmark-tag {
		letter-spacing: 0;
	}

}

</style>
